import React from 'react'
import { dfin } from 'content/constants'
import useCompanyNews from 'data/company/useCompanyNews'
import { useAppInfo } from 'AppState'
import LoadingSkeletonNews from 'components/Loading/LoadingSkeletonNews'
import styles from "./MarketNews.module.css"
import { Skeleton } from '@mui/material'

export default function CompanyNews() {
    const {stateStock,stateTicker} = useAppInfo()
  const tickerCountry = stateTicker.tickerInfo && stateTicker.tickerInfo.filter(obj=>obj[dfin.ticker]===stateStock.companySelected)[0]?.[dfin.country]
  const tickerNews = tickerCountry && tickerCountry==="USA"?stateStock.companySelected:"AAPL"
  const {newsCo,newCoLoading} = useCompanyNews(tickerNews)

  return (
    <>
    <div className={styles.news_container}>
    {newCoLoading && <LoadingSkeletonNews/>}
   
    {!newCoLoading && 
    newsCo.map((obj,index)=>
    <div key={index} 
    className={styles.news_content}
    onClick={()=>{(obj?.content?.canonicalUrl?.url || obj?.content?.clickThroughUrl?.url) &&window.open(obj?.content?.canonicalUrl?.url || obj?.content?.clickThroughUrl?.url, '_blank')}}
    >   
    <div > 
    {obj?.content?.thumbnail && obj?.content?.thumbnail.resolutions && obj?.content?.thumbnail.resolutions[0] && (
            <img src={obj?.content?.thumbnail.resolutions[0].url} 
            className='news_image'/>
          )}
    {(!obj?.content?.thumbnail || !obj?.content?.thumbnail.resolutions || !obj?.content?.thumbnail.resolutions[0]) && (
           <Skeleton variant="rect" className='news_image' />
          )}
  </div>
  <div>

  <a href={obj?.content?.canonicalUrl?.url || obj?.content?.clickThroughUrl?.url} style={{flex:1}} target='blank'>{obj?.content?.title}</a>

  <div style={{gap:"0.5rem",marginTop:"0.5rem"}}>
  <h5>
    {new Date(obj?.content?.pubDate || obj?.content?.displayTime)?.toLocaleDateString('en-US', {
      weekday: 'short',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    })}
  </h5>  
    <h5>Publisher: {obj?.content?.provider?.displayName}</h5>  
    </div>
    </div>
    </div>
    )}
    </div>
    </>
  )
}
